import type { HubSpotConversationsSettings } from "./hubspot-types";

// HubSpot ignores an identification email that arrives without its token, so
// the two are set together or not at all.
export const conversationsSettings = (
  email: string,
  token?: string | null,
): HubSpotConversationsSettings => ({
  loadImmediately: false,
  ...(token && { identificationEmail: email, identificationToken: token }),
});
